var _excluded = ["title", "description", "onBack"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { SCHOOL_LAYER_DEFAULT, SCHOOL_LAYER_HIGH_SCHOOL, SCHOOL_LAYER_COLLEGE } from '../../enums/advanced-option';
import * as commonStyles from './common.style';
import * as styles from './school-panel.style';
import BackButton from './back-button';
import { jsx as ___EmotionJSX } from "@emotion/core";
var SchoolSelectorButton = props => ___EmotionJSX("button", {
  css: styles.selectorButton(props.isSelected),
  onClick: () => {
    props.onClick(props.type);
  },
  type: "button"
}, props.label);
SchoolSelectorButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired
};
var SchoolPanel = _ref => {
  var title = _ref.title,
    description = _ref.description,
    onBack = _ref.onBack,
    props = _objectWithoutProperties(_ref, _excluded);
  return ___EmotionJSX("div", {
    css: commonStyles.container
  }, ___EmotionJSX("p", {
    css: commonStyles.title
  }, title), ___EmotionJSX("div", {
    css: styles.selectorButtonContainer
  }, ___EmotionJSX(SchoolSelectorButton, {
    type: SCHOOL_LAYER_DEFAULT,
    label: "Primary schools",
    onClick: props.onSelect,
    isSelected: props.selected === SCHOOL_LAYER_DEFAULT
  }), ___EmotionJSX(SchoolSelectorButton, {
    type: SCHOOL_LAYER_HIGH_SCHOOL,
    label: "High schools",
    onClick: props.onSelect,
    isSelected: props.selected === SCHOOL_LAYER_HIGH_SCHOOL
  }), ___EmotionJSX(SchoolSelectorButton, {
    type: SCHOOL_LAYER_COLLEGE,
    label: "Colleges",
    onClick: props.onSelect,
    isSelected: props.selected === SCHOOL_LAYER_COLLEGE
  })), ___EmotionJSX("div", {
    css: commonStyles.description,
    dangerouslySetInnerHTML: {
      __html: description
    } // eslint-disable-line react/no-danger
  }), ___EmotionJSX(BackButton, {
    onClick: onBack
  }));
};
SchoolPanel.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  selected: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired
};
SchoolPanel.defaultProps = {
  selected: null
};
export default SchoolPanel;